const LogoRotating = ({ size = 340 }) => (
  <div
    data-testid="3d-hero-logo-container"
    className="relative float-slow"
    style={{ width: size, height: size, perspective: "1200px" }}
  >
    <div
      className="absolute inset-0 rounded-full"
      style={{
        background:
          "radial-gradient(circle, rgba(197,155,39,0.20) 0%, rgba(255,138,0,0.07) 45%, transparent 70%)",
      }}
    />
    <svg
      viewBox="0 0 200 200"
      className="absolute inset-0 h-full w-full animate-[spin_36s_linear_infinite]"
      aria-hidden="true"
    >
      <defs>
        <path
          id="anm-circle"
          d="M100,100 m-80,0 a80,80 0 1,1 160,0 a80,80 0 1,1 -160,0"
          fill="none"
        />
      </defs>
      <text
        style={{ fontFamily: "Cinzel, serif", fontSize: "11px", letterSpacing: "4.5px" }}
        className="fill-[#C59B27]"
      >
        <textPath href="#anm-circle">
          ANM PARIS • MAISON DE PARFUM • ANM PARIS • MAISON DE PARFUM •
        </textPath>
      </text>
    </svg>
    <div className="absolute inset-0 flex items-center justify-center">
      <div
        className="spin-y-slow flex flex-col items-center justify-center rounded-full border border-[#C59B27]/60 bg-gradient-to-br from-white via-[#FDF9F0] to-[#F7EEDB] shadow-[0_30px_80px_-20px_rgba(197,155,39,0.45)]"
        style={{ width: size * 0.62, height: size * 0.62 }}
      >
        <span className="font-accent leading-none text-[#1A1714]" style={{ fontSize: size * 0.155 }}>
          ANM
        </span>
        <span className="mt-2 font-accent tracking-[0.5em] text-[#C59B27]" style={{ fontSize: size * 0.036 }}>
          PARIS
        </span>
        <span className="mt-2 h-px w-1/3 bg-gradient-to-r from-transparent via-[#C59B27] to-transparent" />
      </div>
    </div>
  </div>
);

export default LogoRotating;
